<template>
    <v-sheet color="transparent" class="v-col-12 text-center">
        <greeting-title :user-name="userName" :welcome-text="t('startPage.greetings')" />
    </v-sheet>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { IGreetingCard } from '../types';
import GreetingTitle from '../components/GreetingTitle.vue';

const { t } = useI18n();

defineProps<IGreetingCard>();
</script>
